<div class="modal" *ngIf="opened">
  <div class="modal__content">
    <ng-content></ng-content>

    <button class="modal__close" (click)="onCloseButtonClick()" *ngIf="showCloseButton">
      <span class="icon-remove"></span>
    </button>
  </div>

  <div class="modal__background" (click)="onBackgroundClick()"></div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/modal.component.html